import { createRouter, createWebHistory,createWebHashHistory } from "vue-router";

const routes= [
    {
        path: "/",
        name: "cashierPage",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/cashierPage.vue"),
    },
]


const router = createRouter({
    history: createWebHistory(),
    // history: createWebHashHistory(),
    routes

})

export default router;